import svg from 'url:../../img/icons.svg';

export default class View {
  _data;

  renderSpinner() {
    const markup = `
      <div class="spinner">
        <svg>
          <use href="${svg}#icon-loader"></use>
        </svg>
      </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }
  render(data, render = true) {
    this._data = data;
    const markup = this._generateMarkup();
    if (!render) return markup;

    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  update(data) {
    this._data = data;
    const newMarkup = this._generateMarkup();
    const newDOM = document.createRange().createContextualFragment(newMarkup);
    const newElements = Array.from(newDOM.querySelectorAll('*'));
    let curElements = Array.from(this._parentElement.querySelectorAll('*'));

    newElements.forEach((value, i) => {
      let curEl = curElements[i];
      // console.log(curEl, value.isEqualNode(curEl));

      if (
        !value.isEqualNode(curEl) &&
        value.firstChild?.nodeValue.trim() !== ''
      ) {
        curEl.textContent = value.textContent;
        // console.log(value.firstChild.nodeValue.trim() + '😀😀');
      }
      if (!value.isEqualNode(curEl))
        Array.from(value.attributes).forEach(attr =>
          curEl.setAttribute(attr.name, attr.value)
        );
    });
  }

  renderError(msg = this._errorMsg) {
    let markup = `
    <div class="error">
           <div>
              <svg>
                <use href="${svg}#icon-alert-triangle"></use>
              </svg>
           </div>
        <p>${msg}</p>
    </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }
  renderMessage(msg = this._Msg) {
    let markup = `
    <div class="message">
           <div>
              <svg>
                <use href="${svg}#icon-smile"></use>
              </svg>
           </div>
        <p>${msg}</p>
    </div>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  _clear() {
    this._parentElement.innerHTML = '';
  }
}
